export function normalizeIdentity(identity: string): string {
  return identity.replace(/[^0-9a-zA-Z]/g, '');
}
